{
  "title": "แดชบอร์ด",
  "meta": {
    "sino_last_call": "Sino เรียกล่าสุด {{age}}",
    "marketplace_sync": "ซิงก์มาร์เก็ตเพลส {{age}}"
  },
  "kpi": {
    "block_title": "วันนี้",
    "got_awb": "ได้เลขพัสดุแล้ว",
    "got_awb_caption": "เลขพัสดุ (AWB) ที่ Sino ส่งกลับมา ตามเวลาหยิบ",
    "stuck": "ค้าง (หยิบแล้ว ไม่มีเลขพัสดุ)",
    "stuck_caption": "หยิบแล้วแต่ยังไม่มีเลขพัสดุ",
    "stuck_sub": "ค้าง {{total}} · ลองใหม่ได้ {{n}} →",
    "last_confirm_pick": "ยืนยันหยิบล่าสุด",
    "last_confirm_pick_caption": "นับจากที่ Sino ยืนยันหยิบครั้งล่าสุด",
    "needs_attention": "ต้องตรวจสอบ",
    "needs_attention_caption": "คำสั่งซื้อที่รอการตัดสินใจ",
    "by_reason": "สต็อกเกิน {{oversold}} · ผู้ซื้อขอยกเลิก {{buyer_cancel_requested}} →"
  },
  "win": {
    "h1": "1 ชม.",
    "h24": "24 ชม.",
    "d7": "7 วัน"
  },
  "pipeline": {
    "title": "สถานะมาร์เก็ตเพลส",
    "checked": "ตรวจสอบ{{age}} · รีเฟรชทุกนาที",
    "mp": {
      "shopee": "Shopee",
      "lazada": "Lazada",
      "tiktok": "TikTok"
    },
    "token": "การเชื่อมต่อ",
    "token_hint": "โทเคนเข้าสู่ระบบมาร์เก็ตเพลส",
    "ingest": "ดึงคำสั่งซื้อเข้ามา",
    "ingest_hint": "ดึงล่าสุด · คำสั่งซื้อวันนี้",
    "ingest_today": "· วันนี้ {{n}}",
    "stock_push": "ซิงก์สต็อกไปมาร์เก็ตเพลส",
    "stock_push_hint": "วิธีที่การเปลี่ยนสต็อกไปถึงร้าน",
    "recon_gaps": "ขาดหายเทียบกับ Seller Center",
    "recon_gaps_hint": "คำสั่งซื้อที่ร้านมีแต่ Atlas ไม่มี",
    "connected": "เชื่อมต่อแล้ว",
    "expiring": "หมดอายุใน {{days}} วัน",
    "not_connected": "ไม่ได้เชื่อมต่อ",
    "live": "ใช้งานจริง",
    "paused": "หยุดชั่วคราว {{time}}",
    "shadow": "โหมดทดสอบ",
    "off": "ปิด",
    "reconnect": "เชื่อมต่อใหม่"
  },
  "stuck": {
    "title": "ค้างหลังยืนยันหยิบ",
    "title_count": "ค้างหลังยืนยันหยิบ ({{n}})",
    "caption": "หยิบแล้วแต่ยังไม่มีเลขพัสดุ · เก่าสุดก่อน",
    "include_sof": "รวมขนส่งของผู้ขายเอง",
    "sla_hours": "{{h}} ชม.",
    "picked_at": "หยิบเมื่อ {{time}}",
    "attempts_n": "ลองแล้ว ×{{n}}",
    "col_order": "คำสั่งซื้อ",
    "col_status": "สถานะ",
    "col_stuck": "ค้างมาแล้ว",
    "col_sla": "ต้องส่งภายใน",
    "col_problem": "ปัญหา",
    "cause": {
      "reconnect": "มาร์เก็ตเพลสไม่ได้เชื่อมต่อ",
      "retry": "ขอเลขพัสดุไม่สำเร็จ",
      "pending": "รอการลองครั้งแรก",
      "never_tried": "ไม่เคยขอใบปะหน้า"
    },
    "retry": "ลองดึงเลขพัสดุใหม่",
    "retry_all": "ลองใหม่ทั้งหมด {{n}}",
    "retrying": "กำลังลองใหม่…",
    "view_in_orders": "ดูในคำสั่งซื้อ",
    "empty": "ไม่มีคำสั่งซื้อที่ค้างอยู่"
  },
  "notif": {
    "title": "ต้องดำเนินการ",
    "caption": "การแจ้งเตือน P1/P2 ที่มีขั้นตอนถัดไป",
    "empty": "ไม่มีสิ่งที่ต้องดำเนินการ",
    "action": {
      "reconnect": "เชื่อมต่อใหม่",
      "open_order": "เปิดคำสั่งซื้อ",
      "open_inventory": "เปิดคลังสินค้า",
      "open_inventory_mkp": "เปิดคลังสินค้า {{mkp}}",
      "open_diff": "เปิดส่วนต่าง",
      "open_inbound": "เปิดรับเข้า"
    }
  },
  "age": {
    "just_now": "เมื่อสักครู่",
    "minutes": "{{n}} นาทีที่แล้ว",
    "hours": "{{h}} ชม. {{m}} นาทีที่แล้ว",
    "days": "{{n}} วันที่แล้ว",
    "none": "—"
  },
  "btn": {
    "export": "ส่งออก"
  },
  "error": {
    "block": "โหลดส่วนนี้ไม่สำเร็จ"
  }
}
